<template>
  <v-content>
    <table-view 
      title="Customer"
      :headers="headers"
      :items="customers"
      :forms="forms"
      :buttons="buttons"
      @onEdit="onEdit"
      @onDelete="onDelete"
      @onCancel="onCancel"
      @onSave="onSave"
      @addClicked="addClicked"
      hideActionEdit
      :key="reloadKey"
    >

      <!-- Form Dialog -->
      <template #form-dialog>
        <pos-form
            :form="form"
            :model="customer"
            ref="form"
            class="form-small" />
      </template>

      <!-- Displayed Items -->
      <template #displayed-items="{ childProps }">
        <td class="font-weight-medium">
          {{ childProps.item.createdDate ? $moment(childProps.item.createdDate, "YYYY-MM-DD HH:mm:ss").format("DD MMM HH:mm") : '---' }}
        </td>
        <td class="font-weight-medium">{{ childProps.item.name }}</td>
        <td class="font-weight-medium">
          <template v-if="!childProps.item.locationCount">
            ---
          </template>
          <v-tooltip 
            right v-else
            close-delay="3000"
          >
            <template v-slot:activator="{ on }">
              <v-btn color="primary" flat small icon class="ma-0" v-on="on">
                {{ childProps.item.locationCount }}
              </v-btn>
            </template>
            <span>
              <v-data-table
                :items="childProps.item.locationData"
                :headers="[
                  { text: 'Location', sortable: false },
                  { text: 'Staff', sortable: false }
                ]"
                class="elevation-0"
                hide-actions
              >
                <template v-slot:items="props">
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.staff }}</td>
                </template>
              </v-data-table>
            </span>
          </v-tooltip>
        </td>
        <td class="font-weight-medium">{{ childProps.item.staffCount }}</td>
        <td class="font-weight-medium">{{ childProps.item.contactPerson }}</td>
        <td class="font-weight-medium">{{ childProps.item.email }}</td>
        <td class="font-weight-medium">{{ childProps.item.phone }}</td>
        <td class="font-weight-medium">{{ childProps.item.country }}</td>
        <td class="font-weight-medium">
          <a target="_blank" :href="'https://' + childProps.item.url + '.' + domain">
            {{ childProps.item.url }}.{{ domain }}
          </a>
        </td>
        <td class="font-weight-medium">{{ childProps.item.adminAccount }}</td>
      </template>

    </table-view>
  </v-content>
</template>

<script>
import CustomerTable from '@/tables/customer';
import CustomerForm from '@/forms/customer';
import CustomerService from '@/services/CustomerService';
import { SET_TABLE_DIALOG } from '@/store/mutation-types';
export default {
  name: 'Customer',
  provide() {
    return {
      $parentValidator: this.$validator,
    };
  },
  data() {
    return {
      ...CustomerTable,
      forms: null,
      customer: null,
      reloadKey: 0
    };
  },
  computed: {
    customers() { return this.getArray('customers') },
    form() { return CustomerForm.form(this.customer) },
    domain() { return process.env.VUE_APP_DEPLOY_DOMAIN },
    buttons() {
      return [
        {
          text: this.$gettext('Add Customer'),
          func: this.openModal,
        },
        {
          text: this.$gettext('Refresh Data'),
          func: this.crawl,
          icon: 'fal fa-sync-alt',
          canOpen: false
        }
      ];
    },
  },
  async created() {
    this.resetForm();
  },
  methods: {
    openModal() {
      this.forms = [this.$refs.form];
    },
    resetForm() {
      this.customer = Object.assign({}, CustomerForm.defaultCustomer);
    },
    addClicked() {
      if(!this.forms) this.forms = [this.$refs.form];
      console.log(this.forms.length);
    },
    onEdit(customer){
      if(!this.forms) this.forms = [this.$refs.form];
      this.customer = Object.assign({}, customer);
    },
    async onDelete(customer){
      await CustomerService.delete(customer.id);
    },
    onCancel(){ this.resetForm(); },
    async onSave(){
      let response = false;
      if (this.customer.id !== undefined) {
        response = await CustomerService.update(this.customer);
      } else {
        response = await CustomerService.add(this.customer);
      }
      console.log(response);
      if (response.errors) {
        response.errors.forEach((error) => {
          this.$refs.form.errors.add(error);
        });
      } else {
        this.$store.commit(SET_TABLE_DIALOG, false);
      }
    },
    async crawl() {
      await CustomerService.crawl();
      this.reloadKey++;
    }
  },
  mounted() {
    const _this = this;
    setInterval(()=> {
      _this.crawl();
    }, 120000)
  }
};
</script>
